import { numberToCurrency } from '@/utils'
import type { CreditBundle, Wallet } from '../../types'

export const UNIT_NOUN: Record<Wallet, string> = {
  pages: 'credit',
  screenings: 'screening',
}

export const grantOf = (wallet: Wallet, bundle: CreditBundle) =>
  wallet === 'pages' ? bundle.pagesCreditGrant : bundle.screeningCreditGrant

export const centsPerUnit = (wallet: Wallet, bundle: CreditBundle) => {
  const grant = grantOf(wallet, bundle)
  return grant > 0 ? bundle.unitAmount / grant : 0
}

export const formatPerUnit = (wallet: Wallet, bundle: CreditBundle) => {
  const cents = Math.round(centsPerUnit(wallet, bundle) * 10) / 10
  const value = cents % 1 === 0 ? cents : cents.toFixed(1)
  return `${value}¢ / ${UNIT_NOUN[wallet]}`
}

export const formatPrice = (bundle: CreditBundle) =>
  numberToCurrency(bundle.unitAmount / 100, {
    currency: (bundle.currency || 'usd').toUpperCase(),
  })
